import { colors } from '../../colors';
var pagination = {
  activeColor: colors.deepOrange,
  defaultColor: colors.black
};
export default pagination;